import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { api, sendAsync } from "../../../app/applicationSlice";
import { RootState, RootThunk, RootThunkApi } from "../../../app/store";
import { fromJson, PaymentConfirmation } from "../../../models/confirmation";
import * as R from "../../../models/paymentresult";
import { PaymentResult } from "../../../models/paymentresult";
import { confirmPayment as apiConfirmPayment } from "../../../services/confirmation";
import { pay as apiPay, PayParams } from "../../../services/payment";

interface PaymentConfirmState {
  confirmation?: PaymentConfirmation;
}

const initialState = {} as PaymentConfirmState;

export const pay = createAsyncThunk<PaymentResult, PayParams, RootThunkApi>(
  "confirm/payStatus",
  async (params, api) => {
    return sendAsync(apiPay(params), api).then((data) => R.fromJson(data));
  }
);

const confirmSlice = createSlice({
  name: "confirm",
  initialState,
  reducers: {
    setConfirmation: (state, action: PayloadAction<PaymentConfirmation>) => {
      state.confirmation = action.payload;
    },
    clearConfirmation: (state) => {
      state.confirmation = undefined;
    },
  },
});

const { setConfirmation } = confirmSlice.actions;
export const { clearConfirmation } = confirmSlice.actions;

export const selectConfirmation = (
  state: RootState
): PaymentConfirmation | undefined => state.confirm.confirmation;

export function confirmPayment(ids: string): RootThunk {
  return api(apiConfirmPayment(ids), (data: any, dispatch) => {
    const confirmation = fromJson(data);
    dispatch(setConfirmation(confirmation));
  });
}

export default confirmSlice.reducer;
